import { render, staticRenderFns } from "./SuppBidResultList.vue?vue&type=template&id=d2f96758&"
import script from "./SuppBidResultList.vue?vue&type=script&lang=js&"
export * from "./SuppBidResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports